  import { Component } from '@angular/core';
  import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
  import {CommonProvider} from '../../providers/common/common'
  import {UpdatepersonaleditPage} from '../updatepersonaledit/updatepersonaledit'
  /**
   * Generated class for the UpdatepersonalPage page.
   *
   * See https://ionicframework.com/docs/components/#navigation for more info on
   * Ionic pages and navigation.
   */

  @IonicPage()
  @Component({
    selector: 'page-updatepersonal',
    templateUrl: 'updatepersonal.html',
  })
  export class UpdatepersonalPage {
    infoList:any=[]
    arrResponceCustomerData:any=[]
    constructor(private loadingCtrl:LoadingController,
      public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
    }

    ionViewDidLoad() {
       this.getLightApiData()
    }
     getLightApiData() {
      let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
     loading.present()
    let responcePromice = this.cp.getLightApiData(loading,localStorage.getItem("mobile"));
    responcePromice.then((res: any) => {
      loading.dismiss();
      var res=JSON.parse(res)
      // this.arrResponce = res.Payload.leads;
      if (res.Payload.ibhfl_customerloans) {
        this.arrResponceCustomerData = res.Payload.ibhfl_customerloans;
        var data=this.arrResponceCustomerData.filter((res:any)=>{
          return res.ibhfl_name==localStorage.getItem("cc")
        })
         
        
        if(data.length>0){
          
          this.getPersonalInfo(data[0].customercode);
           
        }
        
      }
      

    }).catch(err => {
    //console.log(err)
    }
    )
  }
    getPersonalInfo(customerCode){
      let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
     loading.present()
      this.cp.getPersonalInfo(loading,customerCode).then((res:any)=>{
        loading.dismiss();
        var res=JSON.parse(res)
        this.infoList.push({"contactid":res.Payload.contacts[0].contactid,
                            "fullname":res.Payload.contacts[0].fullname,
                            "ibhfl_salutation":res.Payload.contacts[0].ibhfl_salutation,
                            "ibhfl_salutation_FormattedValue":res.Payload.contacts[0].ibhfl_salutation_FormattedValue,
                            "ibhfl_displayValue":res.Payload.contacts[0].ibhfl_salutation_FormattedValue,
                            "ibhfl_displayname":'Salutation'},{"contactid":res.Payload.contacts[0].contactid,
                            "fullname":res.Payload.contacts[0].fullname,
                            "ibhfl_maritalstatus":res.Payload.contacts[0].ibhfl_maritalstatus,
                            "ibhfl_maritalstatus_FormattedValue":res.Payload.contacts[0].ibhfl_maritalstatus_FormattedValue,
                            "ibhfl_displayValue":res.Payload.contacts[0].ibhfl_maritalstatus_FormattedValue,
                            "ibhfl_displayname":'Marital status'}
                            );
   })

  }
  goToEditScreen(action){
    //console.log(action)
    this.navCtrl.push(UpdatepersonaleditPage,{queryParams:action});
  }
 } 



// WEBPACK FOOTER //
// ./src/pages/updatepersonal/updatepersonal.ts